import React from 'react';
import FilterbarCheckboxGroup from "../../app/filterbar/filterbar-checkbox-group";
import FilterBar from '../../app/filterbar/filterbar';
import { statuses } from './activity-constants';
import FilterbarRange from "../../app/filterbar/filtebar-range";
import BaseFilterbar from "../../app/filterbar/base-filterbar";

class ActivityFilter extends BaseFilterbar {
  constructor(props) {
    super(props);

    this.state = {
      date: {},
      price: {},
      statuses: statuses.map(status => ({
        ...status,
        checked: true,
      })),
      gyms: [],
    };
  }
  
  componentDidMount() {
    this.getGyms();
  }

  render() {
    return (
      <div className='activityFilter'>
        <FilterBar>
          <FilterbarCheckboxGroup
            title="Status"
            allTitle="Alle statussen"
            options={this.state.statuses}
            onUpdate={this.updateCheckboxFilter.bind(this, 'statuses')}
          />
          <FilterbarCheckboxGroup
            title="Gym"
            allTitle="Alle gyms"
            options={this.state.gyms}
            onUpdate={this.updateCheckboxFilter.bind(this, 'gyms')}
          />
          <FilterbarRange 
            text={true}
            title="Prijs"
            className="priceFilter"
            resetFilter={this.resetFilter.bind(this, 'price')}
            values={this.state.price}
            onChange={this.onInputChange.bind(this, 'price')}
            onCommit={this.commitFilter.bind(this, 'price')}
          />
          <FilterbarRange 
            date={true}
            title="Periode"
            className="dateFilter"
            resetFilter={this.resetFilter.bind(this, 'date')}
            values={this.state.date}
            onChange={this.onInputChange.bind(this, 'date')}
            onCommit={this.commitFilter.bind(this, 'date')}
          />
        </FilterBar>
      </div>
    );
  }
}

export default ActivityFilter;
